import React from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { Box, Divider, Fab, Grid } from '@mui/material'
import { PuiTextArea, Text } from '@pbt/pbt-ui-components'

import type { InventoryOrder } from '~/api/graphql/generated/types'

import { OrderItemsPageHeaderLabels } from './OrderItemsPageHeaderLabels'
import { OrderItemsTableComponent } from './OrderItemsTableComponent'

interface OrderItemsPageProps {
  inventoryOrder: InventoryOrder
}

export const OrderItemsPage = ({ inventoryOrder }: OrderItemsPageProps) => {
  const { t } = useTranslation(['Admin', 'Common'])
  const navigate = useNavigate()

  const navigateToOrdersPage = () => {
    navigate('/admin/catalog/inventories/orders')
  }

  return (
    <Grid
      container
      direction="column"
      height="100%"
      justifyContent="space-between"
      px={3}
      py={2}
    >
      <Grid item sx={{ mt: -2, ml: -3 }} xs={2}>
        <OrderItemsPageHeaderLabels inventoryOrder={inventoryOrder} />
      </Grid>
      <Grid item xs display="flex" flexDirection="column">
        <Text
          sx={(theme) => ({
            color: theme.colors.brandSecondary,
            fontWeight: theme.typography.fontWeightBold,
          })}
        >
          {t('Admin:CATALOG.ORDERS.ITEMS')}
        </Text>
        <OrderItemsTableComponent items={inventoryOrder.items} />
      </Grid>
      <Divider orientation="horizontal" sx={{ my: 6 }} />
      <Grid item xs={2}>
        <Text
          sx={(theme) => ({
            color: theme.colors.brandSecondary,
            fontWeight: theme.typography.fontWeightBold,
          })}
        >
          {t('Common:NOTES')}
        </Text>
        {/* TODO: CVC-13654 Implement notes saving functionality */}
        <PuiTextArea sx={{ width: '500px', mb: 4, mt: 0 }} value="" />
        <Box alignItems="center" display="flex" gap={2} m={1}>
          <Fab
            color="inherit"
            size="small"
            sx={{ px: 4 }}
            variant="extended"
            onClick={navigateToOrdersPage}
          >
            {t('Common:SAVE_ACTION')}
          </Fab>
          <Text link variant="body2" onClick={navigateToOrdersPage}>
            {t('Common:CANCEL_ACTION')}
          </Text>
        </Box>
      </Grid>
    </Grid>
  )
}
